export default __webpack_public_path__ + "static/media/89.9970f03e.png";